export default {
  main: {
    hero: `
        Nei nostri giochi<br>
        trovi <strong>allegri</strong> mondi<br>
        pieni di <strong>simpatici</strong><br>
        personaggi
      `,
    homescapes: `Un leggendario capitolo della serie Scapes™, in cui i giocatori devono rimettere a nuovo una splendida villa insieme al maggiordomo Austin`,
    township: `Un divertente gioco di pianificazione urbana, ricco di eventi, concorsi e competizioni tra giocatori reali`,
  },
  common: {
    login: 'Accedi',
    logout: 'Esci',
    support: 'Assistenza',
    privacy: 'Politica sulla privacy',
    terms: `Termini e condizioni di utilizzo`,
    and: 'e',
    guest: 'Ospite',
    play: 'Gioca',
    install: 'Installa',
  },
  support: {
    title: `Hai bisogno di contattare l'assistenza?`,
    description: `Se stai riscontrando delle difficoltà in questo gioco,
      saremo lieti di aiutarti e rispondere a tutte le tue domande`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Aiuta Austin il maggiordomo a portare calore ed eleganza nella sua magnifica villa di famiglia.',
    description: `Aiuta Austin il maggiordomo a portare calore ed eleganza
      nella sua magnifica villa di famiglia. Forza! Le avventure
      inizieranno non appena varcherai la soglia!`,
    xsolla: 'Xsolla è un distributore globale autorizzato di Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes sul tuo computer!
      Installa la versione web del gioco e vieni a trovare Austin: ci vorranno soltanto un paio di clic!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Costruite la città dei vostri sogni!
      Mietete il raccolto e lavoratelo nei vostri stabilimenti,
      per vendere i beni così prodotti per sviluppare la vostra città.`,
    description: `Costruite la città dei vostri sogni!
      Mietete il raccolto e lavoratelo nei vostri stabilimenti,
      per vendere i beni così prodotti per sviluppare la vostra città.`,
    xsolla: 'Xsolla è un distributore globale autorizzato di Township',
    install: {
      title: '@:common.install',
      text: `Township sul tuo desktop!
      Installa la versione web del gioco e visita la tua città in pochi clic.`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'Questo sito utilizza i cookie per garantire una ottimale esperienza di navigazione',
    link: `Ulteriori informazioni`,
    button: 'Accetta',
  },
  game: {
    notSupported: `I dispositivi mobili non sono supportati.
      Accedi dal tuo computer per giocare.`,
  },
};
